var l = /* @__PURE__ */ ((A) => (A.EXTRA_SMALL = "extra-small", A.SMALL = "small", A.MEDIUM = "medium", A.LARGE = "large", A))(l || {}), m = /* @__PURE__ */ ((A) => (A.PRIMARY = "primary", A.SECONDARY = "secondary", A.INFO = "info", A))(m || {});
export {
  l as VSpinnerSizes,
  m as VSpinnerVariants
};
